
import { defineComponent } from 'vue'
import { useRestaurantModel } from '@entities/restaurant'
import { usePreloaderModel } from '@shared/model/preloader'
import { useBrowserModel } from '@entities/browser'
import { useOrderModel } from '@entities/order'
import { useMetaModel } from '@entities/meta'
import { useLoyaltyModel, application, applicationIikoCard } from '@entities/loyalty'
import { AppButton, ButtonClose } from '@shared/ui'

interface IData {
  scenario: string
  valueBonus: number
  error: boolean
}

export default defineComponent({

  components: { AppButton, ButtonClose },
  emits: [
    'closeActiveModalBonus',
    'setDiscount',
    'callYandexMetricGoal'
  ],

  setup () {
    const restaurantModel = useRestaurantModel()
    const preloaderModel = usePreloaderModel()
    const browserModel = useBrowserModel()
    const orderModel = useOrderModel()
    const metaModel = useMetaModel()
    const loyaltyModel = useLoyaltyModel()

    return {
      restaurantModel,
      preloaderModel,
      browserModel,
      orderModel,
      metaModel,
      loyaltyModel
    }
  },

  data (): IData {
    return {
      scenario: 'first',
      valueBonus: 0,
      error: false
    }
  },

  computed: {
    onlyDiscount (): boolean {
      return this.loyaltyModel.totalNumberBonuses === 0 && this.loyaltyModel.sumDiscountPrimeHill > 0
    },

    textColorStyleLoyalty (): Record<string, string> {
      const loyaltyCode = this.orderModel.orderData?.global_system_loyalty?.code
      if (loyaltyCode === 'prime_hill') {
        return { color: '#6764FF' }
      } else if (loyaltyCode === 'iiko_card') {
        return { color: '#FF6E65' }
      } else {
        return {}
      }
    }
  },

  watch: {
    valueBonus () {
      this.valueBonus > this.loyaltyModel.bonusesWrittenOff ? this.error = true : this.error = false
    }
  },
  mounted () {
    this.valueBonus = this.loyaltyModel.bonusesWrittenOff
  },
  methods: {

    closeModal (val?: boolean) {
      this.$emit('closeActiveModalBonus', val)
    },

    resetInput () {
      this.valueBonus = 0
    },

    toogleScenario (val:string) {
      if (val === 'second') {
        this.$emit('callYandexMetricGoal', 'PHWriteOfBonuses')
      }
      this.scenario = val
    },

    // Обновляем заказ
    async getOrder () {
      await this.orderModel.fetchOrder({
        tableId: this.$route.params.id,
        domen: this.restaurantModel.code,
        session: this.metaModel.session,
        guest: this.metaModel.guest ? Number(this.metaModel.guest) : null,
        browserId: this.browserModel.browserId?.find(i => i.plugin === 'fingerprint')?.browserId || ''
      })
      this.$emit('setDiscount')
      this.closeModal()
      this.preloaderModel.status = false
    },

    // Применяем бонусы
    writeOffBonuses (accumulate: boolean) {
      if (!accumulate) {
        this.$emit('callYandexMetricGoal', 'PHConfirm')
      } else {
        this.$emit('callYandexMetricGoal', 'PHContinueSaving')
      }
      this.preloaderModel.status = true
      const phone = this.$cookies.get('primeHillPhone')
      const loyaltyCode = this.orderModel.orderData?.global_system_loyalty?.code
      if (loyaltyCode === 'prime_hill') {
        application(phone.toString(), +this.metaModel.session!, accumulate ? 0 : this.valueBonus * 100).then((res) => {
          if (res) {
            this.$emit('callYandexMetricGoal', 'PHBonusesApplied')
            this.getOrder()
          }
        }).catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
          this.closeModal(true)
          this.preloaderModel.status = false
        })
      } else if (loyaltyCode === 'iiko_card') {
        applicationIikoCard(phone.toString(), +this.metaModel.session!, accumulate ? 0 : this.valueBonus * 100).then((res) => {
          if (res) {
            this.$emit('callYandexMetricGoal', 'PHBonusesApplied')
            this.getOrder()
          }
        }).catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
          this.closeModal(true)
          this.preloaderModel.status = false
        })
      }
    }
  }
})
